export default {
	namespaced: true,
	state: {
     fields: [
     	{
     		name: 'Name',
     		pattern: '^[a-z]+[a-z\s]*$'
     	},
     	{
     		name: 'Phone',
     		pattern: '^[0-9]+$'
     	},
     	{
     		name: 'Email',
     		pattern: '^[a-z0-9.]+$'
     	},
     	{
     		name: 'Alias',
     		pattern: '^[a-z0-9]+$'
     	}
     ],
     applicationForm: {},
     completed: false,
     deliveryStatus: null
  },
  getters: {
  	fields(state) {
  		return state.fields;
  	},
  	completed(state) {
  		return state.completed;
  	},
  	deliveryStatus(state) {
  		return state.deliveryStatus;
  	},
    applicationForm(state) {
      return state.applicationForm;
    }
  },
  mutations: {
    setFormItem (state, payload) {
        state.applicationForm[payload.name] = {
                value: payload.value,
                completed: payload.completed
            };
        let countFilled = state.fields.reduce(function(n, val) {
            let filled = state.applicationForm[val.name];
            return n + (filled && filled.completed);
        }, 0);
        state.completed = countFilled === state.fields.length;
    },
    setDeliveryStatus (state, status) {
        state.deliveryStatus = status;
    }
  },
  actions: {
    send (state) {
        if (state.deliveryStatus) return;
        state.commit('setDeliveryStatus', 'delivering');
        setTimeout(() => {
            state.commit('setDeliveryStatus', 'delivered');
        }, 1000);
    }
  }
}